import { Box, Center, Text } from '@chakra-ui/react';
import React from 'react';

const SurveyLine: React.FC<{position: string, title: string,fontWeight:string, bgColor: string, textColor: string}> = ({position, title, bgColor, textColor,fontWeight}) => {

    return (
        <Box display="inline-flex" alignItems="center">
            <Center bg={bgColor} width='25px' borderRadius='16px' height='32px'>
                <Text color='white'>{position}</Text>
            </Center>
              <Text fontSize='16px' whiteSpace="nowrap"  ml={1} color={textColor} fontWeight={fontWeight}>{title}</Text>                        
        </Box>
    )
}

export default SurveyLine;